export const accessCheckEvents = {
  STARTED: "InvestorPortal-AccessCheck-Started",
  CODE_REQUESTED: "InvestorPortal-AccessCheck-CodeRequested",
  CODE_ENTERED: "InvestorPortal-AccessCheck-CodeEntered",
  COMPLETED: "InvestorPortal-AccessCheck-Completed",
  REPORT_DOWNLOADED: "InvestorPortal-AccessCheck-ReportDownloaded",
};

export const accessCheckMetrics = {
  SUCCESS: "InvestorPortal-AccessCheck-Success",
  ISSUE_DETECTED: "InvestorPortal-AccessCheck-IssueDetected",
  REPORT_DOWNLOADED: "InvestorPortal-AccessCheck-ReportDownloaded",
};

export const pdfBlobCheckEvents = {
  PDF_LOAD_ERROR: "InvestorPortal-PdfBlobCheck-PdfLoadError",
  COMPLETED: "InvestorPortal-PdfBlobCheck-Completed",
  FAILED: "InvestorPortal-PdfBlobCheck-Failed",
  RETRY_ATTEMPT: "InvestorPortal-PdfBlobCheck-RetryAttempt",
  RETRY_ABORTED: "InvestorPortal-PdfBlobCheck-RetryAborted",
  RETRY_RESOLVED: "InvestorPortal-PdfBlobCheck-RetryResolved",
};

export const registrationEvents = {
  FAILED: "InvestorPortal-Registration-Failed",
};
